import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const Container = styled.article`
  padding-top: 70px;
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
  text-align: center;

  a {
    display: inline-block;
    background-color: black;
    color: white;
    text-decoration: none;
    border: solid 1px black;
    border-radius: 5px;
    padding: 10px;
    margin: 20px;
  }
`;

export default function SuccessPayment() {
  return (
    <Container>
      <h2>Successful Payment</h2>
      <Link to="/products">Continue Shopping</Link>
      <Link to="/">Go to Home Page</Link>
    </Container>
  );
}
